export const SCOTLAND_REGISTER_PATH =
  '/magic-conventions/the-retreat-scotland-2027/register/'

export const scotlandTheme = {
  accentText: 'text-[#744e68]',
  accentBg: 'bg-[#744e68]',
  focusRing: 'focus-visible:ring-[#744e68]',
} as const

const scotlandCdn = (fileName: string) =>
  `https://vinc.gumlet.io/pics/conventions/scotland-retreat/${fileName}`

export const scotlandAssets = {
  hero: scotlandCdn('TheRetreatScotland_WebpageHeader_2.png'),
  logo: scotlandCdn('the-retreat-scotland-logo.png'),
  divider: scotlandCdn('TheRetreatScotland_Webpage_MiddleImage.png'),
  edinburghCastle: scotlandCdn('TheRetreatScotland_EdinburghCastle.png'),
  dunnottarCastle: scotlandCdn('TheRetreatScotland_DunnotarCastle_1.jpg'),
  highlandCows: scotlandCdn('TheRetreatScotland_HighlandCows_1.jpg'),
  foodOne: scotlandCdn('TheRetreatScotland_CameronHouse_2.jpg'),
  foodTwo: scotlandCdn('TheRetreatScotland_CameronHouse_5.jpg'),
  dunkeldHouseExterior: scotlandCdn(
    'TheRetreatScotland_DunkeldHouseHotel_1.png'
  ),
  dunkeldOrangery: scotlandCdn('dunkeld-orangery.jpg'),
  sconePalace: scotlandCdn('scone-palace.jpg'),
  whiskyTasting: scotlandCdn('whisky-tasting.jpg'),
  dunkeldHouse: scotlandCdn('dunkeld.jpg'),
  cameronHouseLochLomond: scotlandCdn('cameron-house-loch-lomond.jpg'),
  cameronHouse: scotlandCdn('cameron-house.jpg'),
  lochLomond: scotlandCdn('loch-lomond.jpg'),
  retreatMagic:
    'https://vigallery.gumlet.io/20/TheRetreatMexicoCity_Photo_187.jpg?w=1400&dpr=2',
  retreatFriends:
    'https://vigallery.gumlet.io/16/TheRetreat_Tuscany2023_Week2_43.jpg?w=1400&dpr=2',
  retreatDinner:
    'https://vigallery.gumlet.io/20/TheRetreatMexicoCity_Photo_249.jpg?w=1400&dpr=2',
} as const
